
import React from 'react';
import { Courier } from '@/services/types';
import { StatusBadge } from '@/components/StatusBadge';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Badge } from '@/components/ui/badge';
import { DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Tag } from 'lucide-react';

interface CourierDetailsHeaderProps {
  courier: Courier;
}

export const CourierDetailsHeader: React.FC<CourierDetailsHeaderProps> = ({ courier }) => {
  return (
    <div className="flex items-center space-x-4">
      <Avatar className="h-12 w-12">
        <AvatarImage src={courier.avatar} alt={courier.name} />
        <AvatarFallback>{courier.name.charAt(0)}</AvatarFallback>
      </Avatar>
      <div>
        <DialogTitle className="text-xl">{courier.name}</DialogTitle>
        <DialogDescription className="flex items-center gap-2">
          <StatusBadge status={courier.status} type="courier" />
          {courier.deal_number && (
            <Badge variant="outline" className="ml-2">
              Сделка: {courier.deal_number}
            </Badge>
          )}
          {courier.tariff && (
            <Badge variant="secondary" className="ml-2">
              <Tag className="h-3 w-3 mr-1" />
              {courier.tariff}
            </Badge>
          )}
        </DialogDescription>
      </div>
    </div>
  );
};
